import React from "react";
// reactstrap components
import {
    Badge,
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Modal,
    PopoverBody,
    Row,
    UncontrolledPopover
} from "reactstrap";
// core components
import UserHeader from "../../components/Headers/UserHeader";
import {Redirect} from "react-router-dom";
import businessHelper from "../../helpers/BusinessHelper";
import businessApiService from "../../api/business-api-service";
import ResourceTableRow from "../../components/Tables/ResourceTableRow";
import ResourceApiService from "../../api/resource-api-service";
import TicketTypeApiService from "../../api/tt-api-service";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";
import {alert_strings} from "../../translations/alert_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import EditTeacherView from "../../components/Resources/Teacher/EditTeacherView";
import {MdCreate, MdDelete} from 'react-icons/md';
import LoadingOverlay from 'react-loading-overlay';
import {RotateCircleLoading} from "react-loadingg";
import ErrorModal from "../../components/Alerts/ErrorModal";
import EditClassTypeView from "../../components/Resources/EditClassTypeView";
import EditTicketTypeView from "../../components/Resources/EditTicketTypeView";
import EditRoomView from "../../components/Resources/EditRoomView";
import PublicProfile from "../../components/PublicProfile";
import storage from "../../Firebase";
import Select from "react-select";
import SelectCurrency from 'react-select-currency';
import constants from "../../shared/constants";
import lsHelpers from "../../helpers/LsHelper";
import LanguagePanel from "../../components/utils/LanguagePanel";
import {localeService} from "../../components/utils/observable/services";
import subscriptionHelpers from "../../helpers/SubscriptionHelper";
import {isMobile} from 'react-device-detect';
import AppModal from "../../components/Alerts/AppModal";
import validationHelper from "../../helpers/ValidationHelper";
import NotProModal from "../../components/Alerts/NotProModal";
import reportApiService from "../../api/report-api-service";
import resourceHelper from "../../helpers/ResourceHelper";
import facebookSvg from "assets/img/icons/sm/facebook.svg"
import twitterSvg from "assets/img/icons/sm/twitter.svg"
import twitterOutlineSvg from "assets/img/icons/sm/twitter_outline.svg"
import instagramSvg from "assets/img/icons/sm/instagram.svg"
import instagramOutlineSvg from "assets/img/icons/sm/instagram_outline.svg"
import facebookOutlineSvg from "assets/img/icons/sm/facebook_outline.svg"
import stripeSvg from "assets/img/icons/common/stripe.svg"
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import teachers from "../Teachers";

const roundButton = {width: 50, height: 50, minWidth: 50, minHeight: 50, borderRadius: 25, padding: 0}

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let alertStrings = new LocalizedStrings(alert_strings);

const addressFields = ["input-street", "input-city", "input-country", "input-postal-code"]
const localeFields = ["input-locale-street", "input-locale-city", "input-locale-country", "input-locale-postal-code", "input-locale-title", "input-locale-description"]

const resourceTable = {marginLeft: 10, marginRight: 10, marginTop: 10}

// const sUrl = "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_FVVYQ2LLjNcHkpAX2boYnb7ChHJDTXGp&scope=read_write";
let subscriptionTooltipText = "";

class Profile extends React.Component {

    constructor(props) {
        super(props);

        this.fileRef = React.createRef();

        this.state = {
            business: businessHelper.business(),
            address: null,
            isLoading: true,
            profileWasUpdated: false,
            showClassTypes: false,
            showRooms: false,
            showTicketTypes: false,
            showTeachers: this.comingFromTeachers(props),
            formData: {},
            classTypes: null,
            ticketTypes: null,
            rooms: null,
            teachers: null,
            showTeacherModal: false,
            showRoomModal: false,
            resourceToDelete: null,
            showDeletionModal: null,
            selectedClassType: null,
            selectedTicketType: null,
            showClassTypeEditor: false,
            showTicketTypeEditor: (props.location.state && props.location.state.goToEditTicketType) || false,
            selectedTeacher: null,
            selectedRoom: null,
            goToTeacher: false,
            goToTeacherId: false,
            pp: null,
            showPP: false,
            uploadingLogo: false,
            uploadingBack: false,
            scrollToTop: false,
            smInputStarted: false,
            selectedSM: null,
            smInput: "",
            showSmInput: false,
            usingReminders: false,
            goToS: false,
            showStripeSuccessModal: false,
            profile: null,
            showSubscriptions: false,
            showLimitReached: false,
            showNotProModal: false,
            isTeacherSession: businessHelper.isTeacherSession(),
            showAppModal: isMobile,
            addressChanged: false,
            editLocaleChanged: false,
            teacherSort: "priority",
            validation: {
                email: true
            },
            editLocale: resourceHelper.emptyLocale()
        };

        this.resolveShowPp()
    }

    handleSubmit = this.handleSubmit.bind(this);
    handleChange = this.handleChange.bind(this);
    editClassType = this.editClassType.bind(this);
    copyClassType = this.copyClassType.bind(this);
    copyTicketType = this.copyTicketType.bind(this);
    editTicketType = this.editTicketType.bind(this);
    deleteClassType = this.deleteClassType.bind(this);
    showClassTypeTable = this.showClassTypeTable.bind(this);
    renderTicketTypeTable = this.renderTicketTypeTable.bind(this);
    showTicketTypeTable = this.showTicketTypeTable.bind(this);
    renderTeacherTable = this.renderTeacherTable.bind(this);
    showTeacherTable = this.showTeacherTable.bind(this);
    renderRoomTable = this.renderRoomTable.bind(this);
    renderRoomHeader = this.renderRoomHeader.bind(this);
    showRoomTable = this.showRoomTable.bind(this);
    showTeacherEditor = this.showTeacherEditor.bind(this);
    showRoomEditor = this.showRoomEditor.bind(this);
    editProfileInfo = this.editProfileInfo.bind(this);
    closeEditTeacherView = this.closeEditTeacherView.bind(this);
    closeEditRoomView = this.closeEditRoomView.bind(this);
    deleteTeacherConfirmation = this.deleteTeacherConfirmation.bind(this);
    deleteRoomConfirmation = this.deleteRoomConfirmation.bind(this);
    deleteCTConfirmation = this.deleteCTConfirmation.bind(this);
    deleteTTConfirmation = this.deleteTTConfirmation.bind(this);
    toggleErrorModal = this.toggleErrorModal.bind(this);
    closeEditClassTypeView = this.closeEditClassTypeView.bind(this);
    closeEditTicketTypeView = this.closeEditTicketTypeView.bind(this);
    handleNetworkError = this.handleNetworkError.bind(this);
    toggleRoomModal = this.toggleRoomModal.bind(this);
    goToTeacher = this.goToTeacher.bind(this);
    showSmEditor = this.showSmEditor.bind(this);
    goToSubscriptions = this.goToSubscriptions.bind(this);
    toggleLocaleEditor = this.toggleLocaleEditor.bind(this);
    saveLocale = this.saveLocale.bind(this);
    deleteLocale = this.deleteLocale.bind(this);
    showLocale = this.showLocale.bind(this);

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextState.scrollToTop === true) {
            window.scrollTo(0, 300);
            this.setState({scrollToTop: false})
        }
    }

    closeEditClassTypeView() {
        this.setState({
            showClassTypeEditor: false,
            showClassTypes: true,
            selectedClassType: null
        });
        this.getClassTypes()
    }

    closeEditTicketTypeView() {
        this.setState({
            showTicketTypeEditor: false,
            showTicketTypes: true,
            selectedTicketType: null
        });

        this.getTicketTypes();
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    saveUserSession(data) {
        businessHelper.saveUserSession(data)
    }

    updatePP(pp) {
        this.setState({pp: pp})
    }

    getUser() {
        businessApiService.current()
            .then(res => {
                this.saveUserSession(res);
                this.setState({
                    business: res.user,
                    address: res.address,
                    locales: res.locales,
                    isLoading: false
                });

                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        name: res.user.name,
                        phone: res.user.phone,
                        street: (res.address && res.address.street) ? res.address.street : "",
                        city: (res.address && res.address.city) ? res.address.city : "",
                        country: (res.address && res.address.country) ? res.address.country : "",
                        zipcode: (res.address && res.address.zipcode) ? res.address.zipcode : ""
                    }
                }));

                this.getProfile();
                this.getPP();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    saveAddress() {
        this.setState({isLoading: true});
        this.setState({
            addressChanged: false,
        });

        const data = {
            street: this.state.formData.street,
            city: this.state.formData.city,
            country: this.state.formData.country,
            zipcode: this.state.formData.zipcode,
        };

        businessApiService.updateAddress(data)
            .then(res => {
                this.getUser()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    updateUser() {
        this.setState({isLoading: true});
        this.setState({
            profileWasUpdated: false,
        });

        const data = {
            name: this.state.formData.name,
            phone: this.state.formData.phone,
            street: this.state.formData.street,
            city: this.state.formData.city,
            country: this.state.formData.country,
            zipcode: this.state.formData.zipcode,
            web: this.state.formData.web,
            email: this.state.formData.email,
            description: this.state.formData.description,
            b_type: this.state.business.b_type,
            custom_message: this.state.formData.custom_message,
        };

        businessApiService.update(data)
            .then(res => {
                this.getUser()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.formData !== this.state.formData) {
            this.validate()
        }
    }

    componentDidMount() {
        this.ppRef = React.createRef();
        this.setState({isLoading: true});

        this.checkStripeLink();
        this.checkQuery();
        this.checkSubscriptionViewRequest()

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        } else {
            this.getUser()
            this.sendAhoy()
        }

    };

    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;
        let checked = event.target.checked;

        if (localeFields.includes(targetId)) {
            this.setState({editLocaleChanged: true})
        }

        if (addressFields.includes(targetId)) {
            this.setState({addressChanged: true})
        } else if (targetId !== "input-reminders-cb" && targetId !== "input-welcome-cb" && targetId !== "input-exp-ticket-cb") {
            this.setState({
                profileWasUpdated: true,
            });
        }

        switch (targetId) {
            case "input-name":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        name: newValue
                    }
                }));
                break;
            case "input-postal-code":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        zipcode: newValue
                    }
                }));
                break;
            case "input-email":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        email: newValue
                    }
                }));
                break;
            case "input-phone":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        phone: newValue
                    }
                }));
                break;
            case "input-web":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        web: newValue
                    }
                }));
                break;
            case "input-city":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        city: newValue
                    }
                }));
                break;
            case "input-description":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        description: newValue
                    }
                }));
                break;
            case "input-custom-message":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        custom_message: newValue
                    }
                }));
                break;
            case "input-street":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        street: newValue
                    }
                }));
                break;
            case "input-country":
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        country: newValue
                    }
                }));
                break;
            case "input-locale-title":
                this.setState(prevState => ({
                    editLocale: {
                        ...prevState.editLocale,
                        title: newValue
                    }
                }));
                break;
            case "input-locale-description":
                this.setState(prevState => ({
                    editLocale: {
                        ...prevState.editLocale,
                        description: newValue
                    }
                }));
                break;
            case "input-locale-postal-code":
                this.setState(prevState => ({
                    editLocale: {
                        ...prevState.editLocale,
                        zipcode: newValue
                    }
                }));
                break;


            case "input-locale-street":
                this.setState(prevState => ({
                    editLocale: {
                        ...prevState.editLocale,
                        street: newValue
                    }
                }));
                break;


            case "input-locale-city":
                this.setState(prevState => ({
                    editLocale: {
                        ...prevState.editLocale,
                        city: newValue
                    }
                }));
                break;

            case "input-locale-country":
                this.setState(prevState => ({
                    editLocale: {
                        ...prevState.editLocale,
                        country: newValue
                    }
                }));
                break;

            case "input-sm":
                this.setState({smInput: newValue, smInputStarted: true});
                break;

            case "input-reminders-cb":
                lsHelpers.saveRemindersPreference(checked);
                this.setState({usingReminders: !this.state.usingReminders});
                break;

            case "input-welcome-cb":
                this.updateWelcomeEmailPrefs(checked);
                break;

            case "input-exp-ticket-cb":
                this.updateExpTicketEmailPrefs(checked);
                break;
            default:
                return
        }
    }

    onSelectedCurrency = currencyAbbrev => {
        this.setState({isLoading: true});
        businessApiService.update({cur: `${currencyAbbrev.target.value}-${this.currencySymbol(currencyAbbrev.target.value)}`})
            .then(res => {
                this.getUser();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    handleSubmit(event) {
        event.preventDefault();
        this.updateUser();
    }

    toggleNotProModal() {
        this.setState({showNotProModal: false})
    }

    render() {
        if (this.state.showPP === true && this.ppRef) {
            window.scrollTo(0, this.ppRef.current.offsetTop);
        }
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            lsHelpers.logout()
            return <Redirect from="*" to="/auth/login"/>
        }

        if (this.state.goToTeacher === true) {
            return <Redirect from="*" to={{
                pathname: "/admin/teacher-profile",
                state: {
                    teacherId: this.state.goToTeacherId
                }
            }}/>
        }

        if (this.state.toMessageSettings) {
            return <Redirect from="*" to={{
                pathname: "/admin/cabinet",
                state: {
                    open_messages: true
                }
            }}/>
        }

        if (this.state.showSubscriptions === true) {
            localStorage.must_reload = true
            return <Redirect from="*" to={{
                pathname: "/admin/subscriptions",
            }}/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    <UserHeader
                        showClassTypes={this.showClassTypeTable}
                        showTicketTypes={this.showTicketTypeTable}
                        showTeachers={this.showTeacherTable}
                        showRooms={this.showRoomTable}
                        editProfile={this.editProfileInfo}
                        showEditButton={!this.showEditProfile()}
                        business={this.state.business}
                    />

                    {this.state.showTeacherModal &&
                        this.renderTeacherModal()
                    }

                    {this.state.showRoomModal &&
                        this.renderRoomModal()
                    }

                    {this.state.showStripeSuccessModal === true &&
                        this.renderStripeSuccessModal()
                    }

                    {this.state.showDeletionModal && this.state.resourceToDelete !== null &&
                        this.renderDeletionModal()
                    }

                    {this.state.showAppModal === true &&
                        this.renderAppModal()
                    }

                    {this.state.showError && <ErrorModal showError={this.state.showError} error={this.state.error}
                                                         toggleErrorModal={this.toggleErrorModal}/>}

                    {this.state.showNotProModal === true && <
                        NotProModal showNotProModal={this.state.showNotProModal}
                                    toggleNotProModal={() => this.toggleNotProModal()}
                                    description={subscriptionTooltipText}
                    />
                    }

                    {/* Page content */}
                    <Container className="mt--7" fluid>
                        <input type="file" id="file" ref={this.fileRef} style={{display: "none"}}
                               onChange={this.onChangeFile.bind(this)}/>
                        <Row>
                            <Col className="order-first mb-5 mb-xl-0" xl="4">
                                <Card className="card-profile shadow">
                                    <Row className="justify-content-center">
                                        <Col className="order-lg-2" lg="3">
                                            <div className="card-profile-image" onClick={this.filePicker.bind(this)}>
                                                <a onClick={e => e.preventDefault()}>
                                                    {this.state.business && this.state.business.logo ? (
                                                        <img
                                                            alt="..."
                                                            className=""
                                                            src={this.state.business.logo}
                                                        />
                                                    ) : (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/brand/open_logo_white.png")}
                                                        />
                                                    )
                                                    }

                                                </a>
                                            </div>
                                            {this.state.isLoading &&
                                                <RotateCircleLoading color="white"/>
                                            }
                                        </Col>
                                    </Row>
                                    <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                                        <div className="d-flex justify-content-between">
                                            <Button
                                                style={{visibility: "hidden"}}
                                                color="secondary"
                                                onClick={e => this.goToSubscriptions(e)}
                                                size="sm"
                                            >
                                                {resourceStrings.subscriptions.manage_subscription}
                                            </Button>
                                            {(!this.state.business || !this.state.business.logo) &&
                                                <Button
                                                    className="float-right"
                                                    color="secondary"
                                                    onClick={this.filePicker.bind(this)}
                                                    size="sm"
                                                >
                                                    {commonStrings.edit_logo}
                                                </Button>
                                            }
                                        </div>
                                    </CardHeader>
                                    <CardBody className="pt-0 pt-md-4">
                                        <Row>
                                            <div className="col">
                                                <div
                                                    className="card-profile-stats d-flex justify-content-center mt-md-5">
                                                    {/*<Button color="default" outline type="button">*/}
                                                    {/*    <span className="heading">10</span>*/}
                                                    {/*    <div className="description">Ticket Types</div>*/}
                                                    {/*</Button>*/}
                                                    {/*<Button color="default" outline type="button">*/}
                                                    {/*    <span className="heading">89</span>*/}
                                                    {/*    <div className="description">Class Types</div>*/}
                                                    {/*</Button>*/}

                                                </div>
                                            </div>
                                        </Row>
                                        <div className="text-center">
                                            {this.state.business && this.state.business.name &&
                                                <h3>
                                                    {this.state.business.name}
                                                </h3>
                                            }

                                            <div>
                                                <Button
                                                    color="warning"
                                                    onClick={e => this.goToSubscriptions(e)}
                                                    size="sm"
                                                >
                                                    <span>{resourceStrings.subscriptions.manage_subscription}</span>
                                                </Button>
                                            </div>

                                            <div className="h5 mt-4">
                                                {this.state.business && this.state.business.address ?
                                                    (
                                                        <span> {this.state.business.address}</span>
                                                    ) :
                                                    (<span></span>)
                                                }
                                            </div>
                                            <hr className="my-4"/>
                                            {/*{this.state.business && this.state.business.description &&*/}
                                            {/*<p>*/}
                                            {/*    {this.state.business.description}*/}
                                            {/*</p>*/}
                                            {/*}*/}
                                            {/*<a href="#pablo" onClick={e => e.preventDefault()}>*/}
                                            {/*    Show more*/}
                                            {/*</a>*/}

                                            <Button
                                                color="info"
                                                className="btn-facebook m-0"
                                                onClick={this.showPublicProfile.bind(this)}
                                            >
                                                {resourceStrings.public_profile.edit_public_profile}
                                            </Button>

                                            <div
                                                className="text-secondary text-black-50 mt-2">
                                                <small>{resourceStrings.public_profile.public_profile_expl}</small>
                                            </div>

                                            <Row className="mt-4">
                                                <Col className="text-right">
                                                    <Button className="btn-icon align-content-center" color="secondary"
                                                            onClick={() => this.showSmEditor("fb")}
                                                            style={{
                                                                padding: 0,
                                                                textAlign: "center",
                                                                width: 24,
                                                                height: 24
                                                            }}>
                                                      <span className="btn-inner--icon my-0 mx-0 px-0 py-0">
                                                        <img
                                                            width={24}
                                                            height={24}
                                                            alt="pm"
                                                            src={this.state.pp && this.state.pp.fb && this.state.pp.fb.length > 0 ? facebookSvg : facebookOutlineSvg}
                                                        />
                                                      </span>
                                                    </Button>

                                                </Col>

                                                <Col>
                                                    <Button className="btn-icon align-content-center" color="secondary"
                                                            onClick={() => this.showSmEditor("insta")}
                                                            style={{
                                                                padding: 0,
                                                                textAlign: "center",
                                                                width: 24,
                                                                height: 24
                                                            }}>
                                                      <span className="btn-inner--icon my-0 mx-0 px-0 py-0">
                                                        <img
                                                            width={24}
                                                            height={24}
                                                            alt="pm"
                                                            src={this.state.pp && this.state.pp.insta && this.state.pp.insta.length > 0 ? instagramSvg : instagramOutlineSvg}
                                                        />
                                                      </span>
                                                    </Button>

                                                </Col>

                                                <Col className="text-left">
                                                    <Button className="btn-icon align-content-center" color="secondary"
                                                            onClick={() => this.showSmEditor("tw")}
                                                            style={{
                                                                padding: 0,
                                                                textAlign: "center",
                                                                width: 24,
                                                                height: 24
                                                            }}>
                                                      <span className="btn-inner--icon my-0 mx-0 px-0 py-0">
                                                        <img
                                                            width={24}
                                                            height={24}
                                                            alt="pm"
                                                            src={this.state.pp && this.state.pp.twitter && this.state.pp.twitter.length > 0 ? twitterSvg : twitterOutlineSvg}
                                                        />
                                                      </span>
                                                    </Button>

                                                </Col>
                                            </Row>

                                            {this.state.showSmInput === true &&
                                                <Row className="mt-4">
                                                    <Col lg="12">
                                                        <FormGroup>

                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                value={this.state.smInput}
                                                                id="input-sm"
                                                                placeholder="https://instagram/open"
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            }
                                            <Row>
                                                {this.state.smInputStarted &&
                                                    <Col lg="12">
                                                        <Button
                                                            onClick={this.saveSm.bind(this)}
                                                            color="warning">
                                                      <span className="btn-inner--icon">
                                                        {commonStrings.save}
                                                      </span>
                                                        </Button>
                                                    </Col>
                                                }
                                            </Row>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>

                            {/*{this.state.showCheckout === true &&*/}
                            {/*<Col className="order-xl-1" xl="8">*/}
                            {/*    <Card className="bg-secondary shadow">*/}
                            {/*        <CardHeader className="bg-white border-0">*/}
                            {/*        </CardHeader>*/}
                            {/*    <Payment*/}
                            {/*    />*/}
                            {/*    </Card>*/}

                            {/*</Col>*/}
                            {/*}*/}

                            {this.state.showClassTypeEditor === true &&
                                <Col className="order-last mb-6" xl="8">

                                    <EditClassTypeView
                                        closeEditClassTypeView={this.closeEditClassTypeView}
                                        classType={this.state.selectedClassType}
                                        handleError={this.handleNetworkError}
                                    />

                                </Col>
                            }

                            {this.state.showTicketTypeEditor === true &&
                                <Col className="order-last mb-6" xl="8">

                                    <EditTicketTypeView
                                        showMembership={(this.props.location.state && this.props.location.state.goToEditTicketType) || false}
                                        closeTicketTypeView={this.closeEditTicketTypeView}
                                        ticketType={this.state.selectedTicketType}
                                        ticketTypes={this.state.ticketTypes}
                                        handleError={this.handleNetworkError}
                                    />

                                </Col>
                            }

                            {this.state.showClassTypes === true &&
                                <Col className="order-last mb-6" xl="8">
                                    <Card className="bg-secondary shadow">
                                        {this.renderCTHeader()}
                                        {this.state.classTypes !== null && this.state.classTypes.length > 0 ?
                                            (<div style={resourceTable}>
                                                    {this.renderClassTypesTable()}
                                                </div>
                                            ) : (
                                                <div style={{width: "1005"}} className="text-center">
                                                    <small><label className="text-gray-dark"
                                                                  style={{margin: 20}}> {resourceStrings.no_class_types} {resourceStrings.class_types_expl} </label></small>
                                                </div>
                                            )
                                        }
                                    </Card>
                                </Col>
                            }
                            {this.state.showTicketTypes === true &&
                                <Col className="mb-6" xl="8">
                                    <Card className="bg-secondary shadow">
                                        {this.renderTTHeader()}
                                        {this.state.ticketTypes !== null && this.state.ticketTypes.length > 0 ?
                                            (<div style={resourceTable}>
                                                    {this.renderTicketTypeTable()}
                                                </div>
                                            ) : (
                                                <div style={{width: "1005"}} className="text-center">
                                                    <small><label className="text-gray-dark"
                                                                  style={{margin: 20}}> {resourceStrings.no_ticket_types} {resourceStrings.ticket_types_expl} </label></small>
                                                </div>
                                            )
                                        }
                                    </Card>
                                </Col>
                            }
                            {this.state.showTeachers === true &&
                                <Col className="order-last mb-6" xl="8">
                                    <Card className="bg-secondary shadow">
                                        {this.renderTeacherHeader()}
                                        {this.state.teachers !== null && this.state.teachers.length > 0 ?
                                            (<div style={resourceTable}>
                                                {this.renderTeacherTable()}
                                            </div>) : (
                                                <div style={{width: "1005"}} className="text-center">
                                                    <small><label className="text-gray-dark"
                                                                  style={{margin: 20}}> {resourceStrings.no_teachers} </label></small>
                                                </div>
                                            )
                                        }
                                    </Card>
                                </Col>
                            }
                            {this.state.showRooms === true &&
                                <Col className="order-last mb-6" xl="8">
                                    <Card className="bg-secondary shadow">
                                        {this.renderRoomHeader()}
                                        {this.state.rooms !== null && this.state.rooms.length > 0 ?
                                            (<div style={resourceTable}>
                                                {this.renderRoomTable()}

                                            </div>) : (
                                                <div style={{width: "1005"}} className="text-center">
                                                    <small><label className="text-gray-dark"
                                                                  style={{margin: 20}}> {resourceStrings.no_rooms}</label></small>
                                                </div>
                                            )
                                        }
                                    </Card>
                                </Col>
                            }

                            <div ref={this.ppRef}/>
                            {this.state.showPP === true &&
                                <Col className="order-last mb-6" xl="8">
                                    <PublicProfile
                                        pp={this.state.pp}
                                        editDescription={this.editProfileInfo}
                                        uploadLogo={this.filePicker.bind(this)}
                                        uploadBack={this.backgroundPicker.bind(this)}
                                        deleteBackground={this.deleteBackground.bind(this)}
                                        deleteLogo={this.deleteLogo.bind(this)}
                                        setTeachers={this.showTeacherTable.bind(this)}
                                        setClasses={this.showClassTypeTable.bind(this)}
                                        handleNetworkError={this.handleNetworkError.bind(this)}
                                        loading={this.loading.bind(this)}
                                        updatePP={this.updatePP.bind(this)}
                                    />
                                </Col>
                            }

                            {this.showEditProfile() === true &&
                                <Col className="order-last mb-6" xl="8">
                                    <Card className="bg-secondary shadow">
                                        <CardHeader className="bg-white border-0">
                                            <Row className="align-items-center">
                                                <Col xs="5">
                                                    <h3 className="mb-0">{commonStrings.navigation.profile}</h3>
                                                </Col>
                                                <Col className="text-right" xs="7">
                                                    {!this.state.profileWasUpdated &&
                                                        <LanguagePanel onResult={this.onLanguageChanged}/>
                                                    }
                                                    {this.state.profileWasUpdated &&
                                                        <Button
                                                            color="default"
                                                            disabled={this.state.isTeacherSession || !this.inputsAreValid()}
                                                            onClick={e => this.handleSubmit(e)}
                                                            size="sm"
                                                        >
                                                            {commonStrings.save}
                                                        </Button>
                                                    }
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                        <CardBody>
                                            <Form onSubmit={this.handleSubmit}>
                                                <h6 className="heading-small text-muted mb-4">
                                                    {/*User information*/}
                                                </h6>
                                                <div className="pl-lg-4">
                                                    <Row>
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-type"
                                                                >
                                                                    {commonStrings.business.business_type}
                                                                </label>
                                                                <Select
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)'
                                                                    }}
                                                                    className="form-control-alternative"
                                                                    value={this.getBusinessType()}
                                                                    onChange={this.handleTypeSelected.bind(this)}
                                                                    options={businessHelper.businessTypes()}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                    </Row>
                                                </div>
                                                <div className="pl-lg-4">
                                                    <Row>
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-name"
                                                                >
                                                                    {commonStrings.business.name}
                                                                </label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    onChange={this.handleChange}
                                                                    defaultValue={this.state.business && this.state.business.name ? this.state.business.name : ''}
                                                                    id="input-name"
                                                                    placeholder="Studio name"
                                                                    type="text"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-email"
                                                                >
                                                                    {commonStrings.email}
                                                                </label>
                                                                <Input
                                                                    className={this.state.validation.email === true ? "form-control-alternative" : "is-invalid"}
                                                                    onChange={this.handleChange}
                                                                    defaultValue={this.state.business && this.state.business.email ? this.state.business.email : ''}
                                                                    id="input-email"
                                                                    placeholder="you@sopenmanagerapp.com"
                                                                    type="email"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-first-name"
                                                                >
                                                                    {commonStrings.business.web}
                                                                </label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    onChange={this.handleChange}
                                                                    defaultValue={this.state.business && this.state.business.web ? this.state.business.web : ""}
                                                                    id="input-web"
                                                                    placeholder="www.yourstudiowebsite.com"
                                                                    type="text"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-last-name"
                                                                >
                                                                    {commonStrings.phone}
                                                                </label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    id="input-phone"
                                                                    onChange={this.handleChange}
                                                                    defaultValue={this.state.business && this.state.business.phone ? this.state.business.phone : ""}
                                                                    placeholder="Phone number"
                                                                    type="tel"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <hr className="my-4"/>
                                                {/* Address */}
                                                <span style={{display: "flex", justifyContent: "space-between"}}
                                                      className="pl-lg-4">
                                                <h6 className="heading-small text-muted mb-4">
                                                    {this.state.showLocaleEditor ? commonStrings.business.locale : commonStrings.business.main_locale}
                                                </h6>

                                                    {/*LOCALE START*/}

                                                    <Button style={{height: 28}} color="default" size="sm"
                                                            onClick={e => this.toggleLocaleEditor(e)}>
                                                    {!this.state.showLocaleEditor &&
                                                        <>
                                                            <i className="fas fa-plus"/> {commonStrings.business.locale}
                                                        </>
                                                    }
                                                        {this.state.showLocaleEditor &&
                                                            <>{commonStrings.close}</>
                                                        }
                                                </Button>

                                                    {/*LOCALE END*/}


                                                </span>
                                                {!this.state.showLocaleEditor &&
                                                    <div className="pl-lg-4">
                                                        <Row>
                                                            <Col md="12">
                                                                <FormGroup>
                                                                    <label
                                                                        className="form-control-label"
                                                                        htmlFor="input-street"
                                                                    >
                                                                        {commonStrings.address}
                                                                    </label>
                                                                    <Input
                                                                        className="form-control-alternative"
                                                                        onChange={this.handleChange}
                                                                        defaultValue={(this.state.address && this.state.address.street) ? this.state.address.street : ""}
                                                                        id="input-street"
                                                                        placeholder="Business Address"
                                                                        type="text"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup>
                                                                    <label
                                                                        className="form-control-label"
                                                                        htmlFor="input-city"
                                                                    >
                                                                        {commonStrings.business.city}
                                                                    </label>
                                                                    <Input
                                                                        className="form-control-alternative"
                                                                        onChange={this.handleChange}
                                                                        defaultValue={this.state.address && this.state.address.city ? this.state.address.city : ""}
                                                                        id="input-city"
                                                                        placeholder="City"
                                                                        type="text"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup>
                                                                    <label
                                                                        className="form-control-label"
                                                                        htmlFor="input-country"
                                                                    >
                                                                        {commonStrings.business.country}
                                                                    </label>
                                                                    <Input
                                                                        className="form-control-alternative"
                                                                        onChange={this.handleChange}
                                                                        defaultValue={this.state.address && this.state.address.country ? this.state.address.country : ""}
                                                                        id="input-country"
                                                                        placeholder="Country"
                                                                        type="text"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup>
                                                                    <label
                                                                        className="form-control-label"
                                                                        htmlFor="input-postal-code"
                                                                    >
                                                                        {commonStrings.business.zipcode}
                                                                    </label>
                                                                    <Input
                                                                        className="form-control-alternative"
                                                                        id="input-postal-code"
                                                                        onChange={this.handleChange}
                                                                        defaultValue={this.state.address && this.state.address.zipcode ? this.state.address.zipcode : ""}
                                                                        placeholder="Postal code"
                                                                        type="number"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        {this.state.addressChanged == true &&
                                                            <Row>
                                                                <Col md="12">
                                                                    <Button
                                                                        className="float-right"
                                                                        color="warning"
                                                                        onClick={this.saveAddress.bind(this)}
                                                                        size="lg"
                                                                    >
                                                                        {commonStrings.save}
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        }
                                                    </div>
                                                }
                                                {this.state.showLocaleEditor && <>{this.renderLocaleEditor()}</>
                                                }
                                                {this.state.locales && this.state.locales.length > 1 &&
                                                    <>
                                                        <h6 className="heading-small text-muted mb-2 mt-2"
                                                            style={{marginLeft: "24px"}}>
                                                            {commonStrings.business.locales}
                                                        </h6>
                                                        <div style={{
                                                            display: "flex", flexFlow: "row", overflowX: "auto",
                                                        }} className="pl-lg-4">
                                                            {this.state.locales.map((locale, index) => {
                                                                return (
                                                                    <Button
                                                                        onClick={e => this.showLocale(e, locale)}
                                                                        key={locale.id.toString() + "w"} style={{
                                                                        paddingLeft: 10,
                                                                        paddingRight: 10,
                                                                        backgroundColor: "#e0cccc",
                                                                        borderRadius: 8,
                                                                        fontSize: "0.8rem",
                                                                        margin: 4,
                                                                        display: "flex",
                                                                        flexFlow: "column",
                                                                    }}>
                                                                        <div>{locale.title}</div>
                                                                        <div
                                                                            style={{
                                                                                fontSize: "0.6rem",
                                                                                color: "white"
                                                                            }}>{locale.address ? locale.address.street : ""}</div>
                                                                    </Button>
                                                                )
                                                            })}
                                                        </div>
                                                    </>
                                                }
                                                <hr className="my-4"/>
                                                {/* Description */}
                                                <h6 className="heading-small text-muted mb-4">{commonStrings.business.business_description}</h6>
                                                <div className="pl-lg-4">
                                                    <FormGroup>
                                                        <label
                                                            className="form-control-label"
                                                            htmlFor="input-description"
                                                        >{commonStrings.description}</label>
                                                        <Input
                                                            className="form-control-alternative"
                                                            id="input-description"
                                                            placeholder={commonStrings.business.business_description_hint}
                                                            onChange={this.handleChange}
                                                            defaultValue={this.state.business && this.state.business.description ? this.state.business.description : ''}
                                                            rows="4"
                                                            type="textarea"
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <hr className="my-4"/>
                                                <div className="pl-lg-4">
                                                    <Row>
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-currency"
                                                                >
                                                                    {commonStrings.business.currency}
                                                                </label>
                                                                <SelectCurrency value={this.currentCurrency()}
                                                                                onChange={this.onSelectedCurrency}
                                                                                id="input-currency"
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "36px"
                                                                                }}/>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-time-format"
                                                                >
                                                                    {commonStrings.business.time_format}
                                                                </label>
                                                                <Select
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)'
                                                                    }}
                                                                    className="form-control-alternative"
                                                                    value={this.getTimeFormat()}
                                                                    onChange={this.handleTimeFormatSelected}
                                                                    options={constants.timeFormats}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <h6 className="heading-small text-muted mb-4">{commonStrings.settings}</h6>

                                                <div className="pl-lg-4">
                                                    <FormGroup>
                                                        <div className="custom-control custom-checkbox mt-4"
                                                        >
                                                            <input
                                                                className="custom-control-input"
                                                                id="input-reminders-cb"
                                                                type="checkbox"
                                                                onChange={this.handleChange}
                                                                checked={lsHelpers.isUsingReminders()}
                                                            />
                                                            <label className="custom-control-label"
                                                                   htmlFor="input-reminders-cb">
                                                                {commonStrings.business.use_reminders}
                                                            </label>
                                                        </div>
                                                    </FormGroup>
                                                    <small className="mt--2">
                                                        <i>{commonStrings.business.use_reminders_expl}</i>
                                                    </small>
                                                </div>

                                                <hr className="my-4"/>

                                                <div style={{
                                                    marginLeft: 20,
                                                    display: "flex",
                                                    flexFlow: "column",
                                                    flexWrap: "wrap",
                                                    justifyContent: "left",
                                                    alignItems: "left"
                                                }}>
                                                    <label>
                                                        {resourceStrings.cabinet.message_settings_expl}
                                                    </label>
                                                    <Button style={{marginTop: 10}}
                                                            onClick={e => this.toMessageSettings(e)}>
                                                        {resourceStrings.cabinet.go_to_message_settings}
                                                    </Button>
                                                </div>
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </Col>
                            }
                        </Row>
                    </Container>
                </>
            </LoadingOverlay>
        );
    }

    toMessageSettings(e) {
        e.preventDefault()
        this.setState({toMessageSettings: true})
    }

    showEditProfile() {
        return this.state.showClassTypes === false && this.state.showTicketTypes === false
            && (this.state.showTeachers === false || this.state.showTeachers === undefined) && this.state.showRooms === false
            && this.state.showClassTypeEditor === false && this.state.showTicketTypeEditor === false
            && this.state.showPP === false
    };

    showClassTypeTable() {
        this.state.classTypes !== null ?
            this.setState({
                showClassTypes: true,
                showClassTypeEditor: false,
                showTicketTypes: false,
                showRooms: false,
                showTeachers: false,
                showPP: false,
                scrollToTop: true,
            }) : this.getClassTypes()
    };

    showRoomTable() {
        this.state.rooms !== null ?
            this.setState({
                showClassTypes: false,
                showTicketTypes: false,
                showRooms: true,
                showClassTypeEditor: false,
                showTicketTypeEditor: false,
                showTeachers: false,
                showPP: false,
                scrollToTop: true,
            }) : this.getRooms()
    };

    getRooms() {
        this.setState({isLoading: true});

        ResourceApiService.rooms()
            .then(res => {
                this.setState({
                    rooms: res,
                    isLoading: false,
                    showLimitReached: this.limitReached("rooms", res.length)
                });

                this.showRoomTable()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    showTeacherTable() {
        this.state.teachers !== null ?
            this.setState({
                showClassTypes: false,
                showTicketTypes: false,
                showRooms: false,
                scrollToTop: true,
                showTeachers: true,
                showRoomEditor: false,
                showClassTypeEditor: false,
                showTicketTypeEditor: false,
                showPP: false,
            }) : this.getTeachers()
    };

    getTeachers() {
        this.setState({isLoading: true});

        ResourceApiService.teachers()
            .then(res => {
                this.setState({
                    teachers: res,
                    isLoading: false,
                    showLimitReached: this.limitReached("teachers", res.length || 0)
                });

                this.showTeacherTable()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    showTicketTypeTable() {
        this.state.ticketTypes !== null ?
            this.setState({
                showClassTypes: false,
                showTicketTypes: true,
                showTicketTypeEditor: false,
                showClassTypeEditor: false,
                showRooms: false,
                showTeachers: false,
                scrollToTop: true,
                showPP: false,
            }) : this.getTicketTypes()
    };

    getTicketTypes() {
        this.setState({isLoading: true});

        TicketTypeApiService.index()
            .then(res => {
                this.setState({
                    ticketTypes: res,
                    isLoading: false,
                    showLimitReached: this.limitReached("tickets", res.length)
                });

                this.showTicketTypeTable()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    handleNetworkError(e) {
        this.setState({
            isLoading: false,
            error: e,
            showError: true,
        });
    }

    editProfileInfo() {
        this.setState({
            showClassTypes: false,
            showTicketTypes: false,
            showRooms: false,
            showTicketTypeEditor: false,
            showClassTypeEditor: false,
            showTeachers: false,
            showPP: false,
        })
    };

    getClassTypes() {
        this.setState({isLoading: true});

        ResourceApiService.classTypes()
            .then(res => {
                this.setState({
                    classTypes: res,
                    isLoading: false,
                    showLimitReached: this.limitReached("classes", res.length)
                });

                this.showClassTypeTable()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    renderClassTypesTable() {
        return this.state.classTypes
            .map((ct, index) => {
                return (
                    <ResourceTableRow item={{name: ct.name, id: ct.id}} key={ct.id}
                                      deleteItem={this.deleteCTConfirmation}
                                      editItem={this.editClassType}
                                      copyItem={this.copyClassType}
                    />
                )
            })
    };

    renderTicketTypeTable() {
        return this.state.ticketTypes
            .map((ct, index) => {
                return (
                    <ResourceTableRow
                        item={{name: ct.name, id: ct.id, membership: ct.membership, is_enrolment: ct.is_enrolment}}
                        key={ct.id}
                        deleteItem={this.deleteTTConfirmation}
                        editItem={this.editTicketType}
                        copyItem={this.copyTicketType}
                    />
                )
            })
    };

    renderRoomTable() {
        return this.state.rooms
            .map((ct, index) => {
                return (
                    <ResourceTableRow item={{name: ct.name, id: ct.id}} key={ct.id}
                                      deleteItem={this.deleteRoomConfirmation}
                                      editItem={this.showRoomEditor}
                    />
                )
            })
    };

    getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        borderRadius: 40,
        background: isDragging ? "#5e72e4" : "#4b5591",
        pointerEvents: "auto",
        cursor: isDragging ? "all-scroll" : "pointer",
        // styles we need to apply on draggables
        ...draggableStyle
    });

    async updateTeacherOrder(event) {
        const {source, destination} = event;
        if (!destination || source.index == destination.index) return;

        let updatedTeachers = this.state.teachers;
        const removed = updatedTeachers.splice(source.index,1);
        updatedTeachers.splice(destination.index, 0, removed);
        updatedTeachers = updatedTeachers.flat();

        this.setState({teachers: updatedTeachers})

        const newPriorityIndices = updatedTeachers.map((zn, index) => {
            return [zn.id, index + 1] // [zoneId, newPriority]
        });

        this.setState({isLoading: true});

        ResourceApiService.setTeacherPriority(newPriorityIndices)
            .then(res => {
                this.setState({
                    isLoading: false,
                    teachers: res.teachers ? res.teachers : updatedTeachers,
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    renderTeacherTable() {

        return <DragDropContext onDragEnd={e => this.updateTeacherOrder(e)}>
            <Droppable droppableId="zone-btn-container">
                {(provided) => {
                    return <div className="text-center bg-info-2" {...provided.droppableProps}
                                ref={provided.innerRef}>
                        {this.state.teachers.map((ct, index) => {
                            const item = {name: ct.name, id: ct.id}
                            return (
                                <Draggable key={ct.id} draggableId={ct.id.toString()} index={index}>
                                    {(provided, snapshot) => {
                                        return <div ref={provided.innerRef}
                                                    key={ct.id}
                                                    {...provided.draggableProps} {...provided.dragHandleProps}
                                                    style={this.getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                    className={`item ${
                                                        snapshot.isDragging ? "dragging" : ""
                                                    }`}>

                                            <div style={{
                                                display: "flex",
                                                flexFlow: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                color: "white",
                                                borderRadius: 40,
                                                marginBottom: 10,
                                                padding: 10
                                            }}>

                                                <div style={{
                                                    display: "flex",
                                                    flexFlow: "row",
                                                    marginLeft: 10,
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    flexWrap: "wrap"
                                                }}>
                                                    <div style={{fontWeight: 600, fontSize: "0.9rem"}}>
                                                        {item.name}
                                                    </div>

                                                </div>

                                                <div style={{display: "flex", flexFlow: "row"}}>
                                                    <Button
                                                        style={roundButton}
                                                        className="btn-icon ct-example-tooltip-static"
                                                        color="warning"
                                                        data-type="error"
                                                        data-tip={commonStrings.delete}
                                                        onClick={e => this.deleteTeacherConfirmation(e, item.id)}>
                                                        <MdDelete/>
                                                    </Button>

                                                    <Button
                                                        style={roundButton}
                                                        color="secondary"
                                                        data-type="info"
                                                        data-tip={commonStrings.edit}
                                                        onClick={e => this.goToTeacher(e, item.id)}>
                                                        <MdCreate/>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    }}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </div>
                }}
            </Droppable>
        </DragDropContext>
    };

    deleteClassType(e) {
        if (e) e.preventDefault();

        const tt = this.state.classTypes.find(it => it.id === this.state.resourceToDelete.id);
        if (tt) {
            this.setState({isLoading: true});
            ResourceApiService.deleteClassType(tt)
                .then(res => {
                    this.setState({
                        isLoading: false,
                        showDeletionModal: false,
                        resourceToDelete: null,
                    });
                    this.getClassTypes()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    };

    editClassType(e, id) {
        if (e) e.preventDefault();

        let ct = this.state.classTypes.find(c => c.id === id) || null;

        this.setState({
            showClassTypeEditor: true,
            showTicketTypeEditor: false,
            showClassTypes: false,
            scrollToTop: true,
            showRooms: false,
            showTeachers: false,
            selectedClassType: ct
        })
    };

    copyClassType(e, id) {
        if (e) e.preventDefault();

        let ct = this.state.classTypes.find(c => c.id === id) || null;
        this.setState({isLoading: true});

        ResourceApiService.copyClassType(ct.id)
            .then(res => {
                this.setState({
                    classTypes: res,
                    isLoading: false
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    editTicketType(e, id) {
        if (e) e.preventDefault();

        let tt = this.state.ticketTypes.find(c => c.id === id) || null;

        this.setState({
            showTicketTypeEditor: true,
            scrollToTop: true,
            showTicketTypes: false,
            selectedTicketType: tt
        })
    };

    copyTicketType(e, id) {
        if (e) e.preventDefault();

        let tt = this.state.ticketTypes.find(c => c.id === id) || null;
        this.setState({isLoading: true});

        ResourceApiService.copyTicketType(tt.id)
            .then(res => {
                this.setState({
                    ticketTypes: res.ticket_types,
                    isLoading: false,
                    showLimitReached: this.limitReached("tickets", res.length)
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    deleteTicketType(e) {
        if (e) e.preventDefault();

        const tt = this.state.ticketTypes.find(it => it.id === this.state.resourceToDelete.id);
        if (tt) {
            this.setState({isLoading: true});
            ResourceApiService.deleteTicketType(tt)
                .then(res => {
                    this.setState({
                        isLoading: false,
                        showDeletionModal: false,
                        resourceToDelete: null,
                    });
                    this.getTicketTypes()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    };

    deleteTeacherConfirmation(e, id) {
        if (e) e.preventDefault();

        this.setState({
            showDeletionModal: true,
            resourceToDelete: {
                type: "teacher",
                id: id,
            }
        })

    };

    deleteRoomConfirmation(e, id) {
        if (e) e.preventDefault();

        this.setState({
            showDeletionModal: true,
            resourceToDelete: {
                type: "room",
                id: id,
            }
        })

    };

    deleteTTConfirmation(e, id) {
        if (e) e.preventDefault();

        this.setState({
            showDeletionModal: true,
            resourceToDelete: {
                type: "tt",
                id: id,
            }
        })

    };

    deleteCTConfirmation(e, id) {
        if (e) e.preventDefault();

        this.setState({
            showDeletionModal: true,
            resourceToDelete: {
                type: "ct",
                id: id,
            }
        })

    };

    deleteResource() {
        switch (this.state.resourceToDelete.type) {
            case "teacher":
                this.deleteTeacher();
                break;
            case "tt":
                this.deleteTicketType();
                break;
            case "ct":
                this.deleteClassType();
                break;
            case "room":
                this.deleteRoom();
                break;
            default:
                return
        }
    }

    deleteTeacher() {
        const t = this.state.teachers.find(it => it.id === this.state.resourceToDelete.id);
        if (t) {
            this.setState({isLoading: true});
            ResourceApiService.deleteTeacher(t)
                .then(res => {
                    this.setState({
                        isLoading: false,
                        showDeletionModal: false,
                        resourceToDelete: null,
                    });

                    this.getTeachers()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    deleteRoom(e) {
        if (e) e.preventDefault();

        const r = this.state.rooms.find(it => it.id === this.state.resourceToDelete.id);
        if (r) {
            this.setState({isLoading: true});
            ResourceApiService.deleteRoom(r)
                .then(res => {
                    this.setState({
                        isLoading: false,
                        showDeletionModal: false,
                        resourceToDelete: null,
                    });
                    this.getRooms()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    };

    renderTeacherHeader() {
        return <CardHeader className="bg-secondary shadow">
            <Row className="align-items-center">
                <div className="col">
                    <h2 className="text-default mb-0">{resourceStrings.teachers}
                        <i
                            className="fas fa-info-circle ml-2 text-gray"
                            id="teacher_popover"
                        />

                        <Button className="btn-icon align-content-center" color="secondary"
                                onClick={() => this.toggleSort()}
                                style={{
                                    padding: 0,
                                    textAlign: "center",
                                    width: 30,
                                    height: 30,
                                    marginLeft: 10,
                                    marginBottom: 5
                                }}>
                                  <span className="btn-inner--icon">
                                    <img
                                        width={24}
                                        height={24}
                                        alt="pm"
                                        src={this.state.teacherSort === "az" ? require("assets/img/brand/sort-az.png") : require("assets/img/brand/list.png")}
                                    />
                                  </span>
                        </Button>
                    </h2>
                </div>

                <div style={{marginLeft: 15, marginRight: 15, marginBottom: 10}}>
                    <small>
                        {this.state.teacherSort === "az" ? resourceStrings.teachers_sort_az : resourceStrings.teachers_sort_priority}
                    </small>
                </div>
                <UncontrolledPopover placement="top" target="teacher_popover">
                    <PopoverBody>
                        {this.teacherInfoText()}
                    </PopoverBody>
                </UncontrolledPopover>
                <div className="col text-right">
                    <Button
                        color="warning"
                        onClick={this.state.showLimitReached ? this.renderLimitReachedPopup.bind(this) : this.showTeacherEditor}
                        size="sm"
                    >
                        {resourceStrings.add_teacher}
                    </Button>
                </div>
            </Row>
            {this.state.showLimitReached &&
                <div>
                    {this.renderLimitReachedBadge()}
                </div>
            }
        </CardHeader>
    }

    toggleSort() {
        if (this.state.teacherSort !== "az") {
            this.setState({teachers: this.state.teachers.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))})
        }
        else {
            this.setState({teachers: this.state.teachers.sort((a,b) => (a.priority || 999) - (b.priority || 999))})
        }

        this.setState({teacherSort: this.state.teacherSort === "az" ? "priority" : "az"})
    }

    renderRoomHeader() {
        return <CardHeader className="bg-secondary shadow">
            <Row className="align-items-center">
                <div className="col">
                    <h2 className="text-default mb-0">{resourceStrings.rooms}
                        <i
                            className="fas fa-info-circle ml-2 text-gray"
                            id="room_popover"
                        />
                    </h2>
                    <UncontrolledPopover placement="top" target="room_popover">
                        <PopoverBody>
                            {this.roomInfoText()}
                        </PopoverBody>
                    </UncontrolledPopover>
                </div>
                <div className="col text-right">
                    <Button
                        color="warning"
                        onClick={this.state.showLimitReached ? this.renderLimitReachedPopup.bind(this) : this.showRoomEditor}
                        size="sm"
                    >
                        {resourceStrings.add_room}
                    </Button>
                </div>
            </Row>

            {this.state.showLimitReached &&
                <div>
                    {this.renderLimitReachedBadge()}
                </div>
            }
        </CardHeader>
    }

    renderCTHeader() {
        return <CardHeader className="bg-secondary shadow">
            <Row className="align-items-center">
                <div className="col">
                    <h2 className="text-default mb-0">{resourceStrings.class_types}
                        <i
                            className="fas fa-info-circle ml-2 text-gray"
                            id="ct_popover"
                        />
                    </h2>
                    <UncontrolledPopover placement="top" target="ct_popover">
                        <PopoverBody>
                            {this.classTypeInfoText()}
                        </PopoverBody>
                    </UncontrolledPopover>
                </div>
                <div className="col text-right">
                    <Button
                        color="warning"
                        onClick={this.state.showLimitReached ? this.renderLimitReachedPopup.bind(this) : this.editClassType}
                        size="sm"
                    >
                        {resourceStrings.add_class_type}
                    </Button>
                </div>
            </Row>
            {this.state.showLimitReached &&
                <div>
                    {this.renderLimitReachedBadge()}
                </div>
            }
        </CardHeader>
    }

    renderTTHeader() {
        return <CardHeader className="bg-secondary shadow">
            <Row className="align-items-center">
                <div className="col">
                    <h2 className="text-default mb-0">{resourceStrings.ticket_types}
                        <i
                            className="fas fa-info-circle ml-2 text-gray"
                            id="tt_popover"
                        />
                    </h2>
                    <UncontrolledPopover placement="top" target="tt_popover">
                        <PopoverBody>
                            {this.ticketTypeInfoText()}
                        </PopoverBody>
                    </UncontrolledPopover>
                </div>
                <div className="col text-right">
                    <Button
                        color="warning"
                        onClick={this.state.showLimitReached ? this.renderLimitReachedPopup.bind(this) : this.editTicketType}
                        size="sm"
                    >
                        {resourceStrings.add_tt}
                    </Button>
                </div>
            </Row>
            {this.state.showLimitReached &&
                <div>
                    {this.renderLimitReachedBadge()}
                </div>
            }
        </CardHeader>
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    showTeacherEditor(e, id = -1) {
        if (e) e.preventDefault();
        const t = this.state.teachers.find(it => it.id === id) || null;
        this.setState({showTeacherModal: true, selectedTeacher: t})
    }

    showRoomEditor(e, id = -1) {
        if (e) e.preventDefault();
        const t = this.state.rooms.find(it => it.id === id) || null;
        this.setState({showRoomModal: true, selectedRoom: t})
    }

    toggleTeacherModal = state => {
        this.setState({
            showTeacherModal: !this.state.showTeacherModal
        });
    };

    closeEditTeacherView(e, teacherId) {
        if (e) {
            e.preventDefault();
        }

        this.setState({showTeacherModal: false, selectedTeacher: null});
        this.getTeachers();
        if (teacherId) this.goToTeacher(null, teacherId);
    }

    closeEditRoomView(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({showRoomModal: false, selectedRoom: null});
        this.getRooms()
    }


    renderTeacherModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showTeacherModal}
                toggle={() => this.toggleTeacherModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.add_teacher}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <EditTeacherView
                                closeEditTeacherView={this.closeEditTeacherView}
                                modal={true}
                                teacher={this.state.selectedTeacher}
                                handleError={this.handleNetworkError}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    toggleRoomModal() {
        this.setState({
            showRoomModal: !this.state.showRoomModal
        });
    };

    renderRoomModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showRoomModal}
                toggle={() => this.toggleRoomModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.add_room}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <EditRoomView closeEditRoomView={this.closeEditRoomView}
                                          handleError={this.handleNetworkError}
                                          room={this.state.selectedRoom}/>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    toggleDeletionModal = state => {
        this.setState({
            showDeletionModal: !this.state.showDeletionModal
        });
    };

    renderDeletionModal() {
        return (
            <Modal
                className="modal-dialog-centered modal-danger"
                contentClassName="bg-gradient-danger"
                isOpen={this.state.showDeletionModal}
                toggle={() => this.toggleDeletionModal("notificationModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {/*Your attention is required*/}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleDeletionModal("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center">
                        <MdDelete size="50px"/>
                        {alertStrings.confirmation_alert_title}
                        <p>
                            {this.deleteConfirmationText()}
                        </p>
                    </div>
                </div>
                <div className="modal-footer">
                    <Col className="text-center">
                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={() => this.deleteResource()}>
                            {alertStrings.yes}
                        </Button>

                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.toggleDeletionModal}>
                            {alertStrings.no}
                        </Button>

                    </Col>
                </div>
            </Modal>
        )
    }

    deleteConfirmationText() {
        switch (this.state.resourceToDelete.type) {
            case "teacher":
                return alertStrings.confirm_delete_teacher;
            case "tt":
                return alertStrings.confirm_delete_tt;
            case "ct":
                return alertStrings.confirm_delete_ct;
            case "room":
                return alertStrings.confirm_delete_room;
            default:
                return
        }
    }

    goToTeacher(e, id) {
        if (e) e.preventDefault();

        this.setState({
            goToTeacher: true,
            goToTeacherId: id,
        });
    }

    comingFromTeachers(props) {
        if (!props) return false;
        else if (props.location && props.location.state && props.location.state.showTeachers) {
            this.getTeachers();
            return props.location.state.showTeacehrs || false
        }
    }

    // Public Profile

    showPublicProfile() {
        window.location.href = `/admin/public-profile`;
    }

    getPP(andShow = false) {
        this.setState({
            isLoading: true
        });

        businessApiService.publicProfile()
            .then(res => {
                this.setState({
                    pp: res,
                    isLoading: false
                });

                if (andShow) {
                    this.setState({
                        showPP: true
                    });
                }

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getProfile() {
        this.setState({
            isLoading: true
        });

        businessApiService.profile()
            .then(res => {
                this.setState({
                    profile: res,
                    isLoading: false
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    // LOGO

    filePicker(e) {
        this.setState({uploadingLogo: true, uploadingBack: false});
        this.fileRef.current.click();
    }

    backgroundPicker(e) {
        this.setState({uploadingLogo: false, uploadingBack: true});
        this.fileRef.current.click();
    }

    deleteBackground(e) {
        e.preventDefault();
        e.stopPropagation();
        this.deleteBackgroundPhoto();
    }

    onChangeFile(event) {
        event.stopPropagation();
        event.preventDefault();
        const file = event.target.files[0];
        console.log(file);
        this.setState({file}); /// if you want to upload latter
        this.state.uploadingLogo ? this.uploadFile(file) : this.uploadBackgroundPhoto(file);
    }

    deleteBackgroundPhoto() {
        this.setState({
            isLoading: true,
        });
        const businessId = businessHelper.business().id;

        const deleteRef = storage.ref(`backgrounds/${businessId}/user_photo${this.state.business.id}`);

        // Delete the file
        deleteRef.delete().then(() => {
        }).catch((error) => {
        });

        const deleteRef2 = storage.ref(`backgrounds/${businessId}/user_photo_${this.state.business.id}`);
        deleteRef2.delete().then(() => {

        }).catch((error) => {
        });

        this.updateBusinessPhoto("");

    };

    deleteLogo(e) {
        e.stopPropagation();
        e.preventDefault();
        this.setState({
            isLoading: true,
        });
        const businessId = businessHelper.business().id;

        var deleteRef = storage.ref(`logos/${businessId}/user_logo_${this.state.business.id}`);

        // Delete the file
        deleteRef.delete().then(() => {
            this.updateBusinessLogo("");
        }).catch((error) => {
            this.handleNetworkError(error);
        });

    };

    uploadBackgroundPhoto(file) {
        if (!file) return;

        this.setState({
            isLoading: true,
        });
        const businessId = businessHelper.business().id;
        const uploadTask = storage.ref(`backgrounds/${businessId}/user_photo_${this.state.business.id}`).put(file);
        uploadTask.on(
            "state_changed",
            snapshot => {
                // progress function ...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                this.setState({progress});
            },
            error => {
                this.setState({
                    isLoading: false,
                });
                this.handleNetworkError(error);
                console.log(error);
            },
            () => {
                storage
                    .ref(`backgrounds/${businessId}`)
                    .child(`user_photo_${this.state.business.id}`)
                    .getDownloadURL()
                    .then(url => {
                        this.setState({url});
                        this.updateBusinessPhoto(url);
                    });
            }
        );
    };

    uploadFile(file) {
        if (!file) return;

        this.setState({
            isLoading: true,
        });

        const businessId = businessHelper.business().id;
        const uploadTask = storage.ref(`logos/${businessId}/user_logo_${this.state.business.id}`).put(file);
        uploadTask.on(
            "state_changed",
            snapshot => {
                // progress function ...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                this.setState({progress});
            },
            error => {
                this.setState({
                    isLoading: false,
                });
                this.handleNetworkError(error);
                console.log(error);
            },
            () => {
                storage
                    .ref(`logos/${businessId}`)
                    .child(`user_logo_${this.state.business.id}`)
                    .getDownloadURL()
                    .then(url => {
                        this.setState({url});
                        this.state.uploadingLogo ? this.updateBusinessLogo(url) : this.updateBusinessPhoto(url);
                    });
            }
        );
    };

    updateBusinessPhoto(url) {
        this.setState({isLoading: true});
        businessApiService.update({photo: url})
            .then(res => {
                this.setState({isLoading: false, scrollToTop: true});
                this.getUser();
            })
            .catch((e) => {
                this.setState({isLoading: false});
                this.handleNetworkError(e)
            });
    }

    updateBusinessLogo(url) {
        this.setState({isLoading: true});
        businessApiService.update({logo: url})
            .then(res => {
                this.setState({isLoading: false});
                this.getUser();
            })
            .catch((e) => {
                this.setState({isLoading: false});
                this.handleNetworkError(e)
            });
    }

    loading(b = true) {
        this.setState({isLoading: b})
    }

    saveSm() {
        this.setState({smInputStarted: false});
        let smData = {};
        switch (this.state.selectedSM) {
            case "fb":
                smData = {fb: this.state.smInput};
                break;
            case "tw":
                smData = {twitter: this.state.smInput};
                break;
            case "insta":
                smData = {insta: this.state.smInput};
                break;
            default:
                break;
        }

        businessApiService.updateSM(smData)
            .then(res => {
                this.getUser();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    showSmEditor(type) {
        let data;
        if (this.state.pp) {
            switch (type) {
                case "fb":
                    data = this.state.pp.fb || "";
                    break;
                case "tw":
                    data = this.state.pp.twitter || "";
                    break;
                case "insta":
                    data = this.state.pp.insta || "";
                    break;
                default:
                    data = "";
                    break;
            }
        } else {
            data = "";
        }
        this.setState({showSmInput: true, smInput: data, smInputStarted: false, selectedSM: type})
    }

    checkStripeLink() {
        const query = new URLSearchParams(this.props.location.search);
        const code = query.get('code');

        if (code && code.length > 1) this.postSCode(code)
    }

    checkSubscriptionViewRequest() {
        const query = new URLSearchParams(this.props.location.search);
        if (query && query.get('subscription') === 't') {
            this.goToSubscriptions();
        }
    }

    postSCode(code) {
        this.setState({isLoading: true});
        businessApiService.connectStripe(code)
            .then(res => {
                this.getUser();
                this.setState({showStripeSuccessModal: true})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    toggleStripeSuccessModal = state => {
        this.setState({
            showStripeSuccessModal: !this.state.showStripeSuccessModal
        });
    };

    renderStripeSuccessModal() {
        return (<Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={this.state.showStripeSuccessModal}
            toggle={() => this.toggleStripeSuccessModal("notificationModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleStripeSuccessModal("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <img
                        alt="..."
                        width={64}
                        height={64}
                        src={stripeSvg}/>
                    <h4 className="heading mt-4">{alertStrings.success}</h4>
                    <p>
                        {alertStrings.success_stripe}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleStripeSuccessModal("notificationModal")}
                >
                    {commonStrings.close}
                </Button>
            </div>
        </Modal>)
    }

    getBusinessType() {
        if (this.state.business != null) {
            let t = businessHelper.businessTypes().find(p => p.value === this.state.business.b_type);

            if (t === undefined) {
                t = businessHelper.businessTypes()[0]
            }

            return t
        } else {
        }
    }

    getTimeFormat() {
        if (this.state.profile != null) {
            let t = constants.timeFormats.find(it => it.value === this.state.profile.time_format);

            if (t === undefined) {
                t = constants.timeFormats[0]
            }

            return t
        } else {
            return constants.timeFormats[0]
        }
    }

    handleTypeSelected = selectedOption => {
        this.setState(prevState => ({
            business: {
                ...prevState.business,
                b_type: selectedOption.value
            },
            profileWasUpdated: true
        }));
    };

    handleTimeFormatSelected = selectedOption => {
        this.setState({isLoading: true});
        businessApiService.update({time_format: selectedOption.value})
            .then(res => {
                this.getUser();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    onLanguageChanged = (locale) => {
        localeService.setLocale(locale);
        this.setState({isLoading: true});

        businessApiService.updateLocale({locale: locale})
            .then(res => {
                this.getUser();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    currentCurrency() {
        return businessHelper.currencyLabel()
    }

    currencySymbol(value) {
        switch (value) {
            case "USD":
                return "$";
            case "EUR":
                return "€";
            case "RUB":
                return "₽";
            case "UAH":
                return "₴";
            case "CLP":
                return "$";
            default:
                return value;

        }
    }

    goToSubscriptions(e = null) {
        if (e) e.preventDefault();
        this.setState({showSubscriptions: true})
    }

    limitReached(type, numberOfItems) {
        const subscription = subscriptionHelpers.subscriptionPlan();
        if ([resourceStrings.subscriptions.pro_plan, resourceStrings.subscriptions.premium_plan, resourceStrings.subscriptions.ent_plan].includes(subscription)) {
            return false
        } else {
            const isPrivate = resourceStrings.subscriptions.private_plan === subscription;
            switch (type) {
                case "classes":
                    if (isPrivate) {
                        subscriptionTooltipText = resourceStrings.subscriptions.private_expl
                        return numberOfItems >= 4
                    } else {
                        subscriptionTooltipText = resourceStrings.subscriptions.free_plan_expl
                        return numberOfItems >= 2
                    }
                case "tickets":
                    if (isPrivate) {
                        subscriptionTooltipText = resourceStrings.subscriptions.private_expl
                        return numberOfItems >= 4
                    } else {
                        subscriptionTooltipText = resourceStrings.subscriptions.free_plan_expl
                        return numberOfItems >= 2
                    }
                case "teachers":
                    if (isPrivate) {
                        subscriptionTooltipText = resourceStrings.subscriptions.private_expl
                        return numberOfItems >= 2
                    } else {
                        subscriptionTooltipText = resourceStrings.subscriptions.free_plan_expl
                        return numberOfItems >= 1
                    }
                case "rooms":
                    if (isPrivate) {
                        subscriptionTooltipText = resourceStrings.subscriptions.private_expl
                        return numberOfItems >= 0
                    } else {
                        subscriptionTooltipText = resourceStrings.subscriptions.free_plan_expl
                        return numberOfItems >= 0
                    }
                default:
                    return false
            }
        }
    }

    toggleAppModal() {
        this.setState({showAppModal: !this.state.showAppModal})
    }

    renderAppModal() {
        if (lsHelpers.canShowAppModal()) {
            return <AppModal toggleAppModal={this.toggleAppModal.bind(this)} showAppModal={this.state.showAppModal}/>
        }
    }

    classTypeInfoText() {
        return commonStrings.tutorial.class_types.body_1 + commonStrings.tutorial.class_types.body_1_1 + commonStrings.tutorial.class_types.body_2 + commonStrings.tutorial.class_types.body_3 + commonStrings.tutorial.class_types.body_4
    }

    ticketTypeInfoText() {
        return commonStrings.tutorial.ticket_types.body_1
    }

    roomInfoText() {
        return commonStrings.tutorial.rooms.body_1 + commonStrings.tutorial.rooms.body_2 + commonStrings.tutorial.rooms.body_3 + commonStrings.tutorial.rooms.body_4 + commonStrings.tutorial.rooms.body_5
    }

    teacherInfoText() {
        return commonStrings.tutorial.teachers.body_1 + " " + commonStrings.tutorial.teachers.body_2 + commonStrings.tutorial.teachers.body_3
    }

    validate() {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                email: validationHelper.emailIsValid(this.state.formData.email)
            }
        }));
    }

    inputsAreValid() {
        return Object.values(this.state.validation).every(item => item)
    }

    renderLimitReachedBadge() {
        return <span className="text_align-center">
            <Badge
                color="warning"
                href="#subscriptions" onClick={e => this.goToSubscriptions(e)}>
            {resourceStrings.subscriptions.limit_reached}
            </Badge> <i
            className="fas fa-info-circle ml-2 text-white"
            id="limit_popover"
        /> <UncontrolledPopover placement="top" target="limit_popover">
            <PopoverBody>
                {subscriptionTooltipText}
            </PopoverBody>
        </UncontrolledPopover> </span>
    }

    renderLimitReachedPopup() {
        this.setState({showNotProModal: true})
    }

    sendAhoy() {
        reportApiService.ahoy("profile_view")
    }

    updateWelcomeEmailPrefs(checked) {
        businessApiService.updateWelcomeEmailPrefs(checked)
            .then(res => {
                this.getUser()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    toggleLocaleEditor(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }

        if (this.state.showLocaleEditor) {
            this.setState({editLocaleChanged: false, showLocaleEditor: false, editLocale: resourceHelper.emptyLocale()})
        } else {
            this.setState({showLocaleEditor: true})
        }

    }

    renderLocaleEditor() {
        return (
            <div className="pl-lg-4" style={{borderRadius: 6, backgroundColor: "#e0cccc", padding: "1.5rem"}}>
                <label>{commonStrings.business.locale_expl}</label>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-locale-title"
                            >
                                {resourceStrings.title}
                            </label>
                            <Input
                                className="form-control-alternative"
                                onChange={this.handleChange}
                                value={this.state.editLocale ? this.state.editLocale.title : ""}
                                id="input-locale-title"
                                type="text"
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-locale-description"
                            >
                                {resourceStrings.description}
                            </label>
                            <Input
                                className="form-control-alternative"
                                onChange={this.handleChange}
                                value={this.state.editLocale ? this.state.editLocale.description : this.state.business.description}
                                id="input-locale-description"
                                type="textarea"
                                rows={3}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-locale-street"
                            >
                                {commonStrings.address}
                            </label>
                            <Input
                                className="form-control-alternative"
                                onChange={this.handleChange}
                                value={(this.state.editLocale && this.state.editLocale.street) ? this.state.editLocale.street : ""}
                                id="input-locale-street"
                                type="text"
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-locale-city"
                            >
                                {commonStrings.business.city}
                            </label>
                            <Input
                                className="form-control-alternative"
                                onChange={this.handleChange}
                                value={this.state.editLocale && this.state.editLocale.city ? this.state.editLocale.city : ""}
                                id="input-locale-city"
                                type="text"
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-locale-country"
                            >
                                {commonStrings.business.country}
                            </label>
                            <Input
                                className="form-control-alternative"
                                onChange={this.handleChange}
                                value={this.state.editLocale && this.state.editLocale.country ? this.state.editLocale.country : ""}
                                id="input-locale-country"
                                type="text"
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-locale-postal-code"
                            >
                                {commonStrings.business.zipcode}
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-locale-postal-code"
                                onChange={this.handleChange}
                                value={this.state.editLocale && this.state.editLocale.zipcode ? this.state.editLocale.zipcode : ""}
                                type="text"
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <div style={{display: "flex", flexFlow: "row", justifyContent: "flex-end"}}>
                    {this.state.editLocale && this.state.editLocale.id &&
                        <Button
                            className="float-right"
                            color="danger"
                            onClick={e => this.deleteLocale(e)}
                            size="sm"
                        >
                            {commonStrings.delete}
                        </Button>
                    }
                    <Button
                        className="float-right"
                        color="warning"
                        disabled={!(this.state.editLocale && this.state.editLocale.title && this.state.editLocale.title.length > 2)}
                        onClick={e => this.saveLocale(e)}
                        size="sm"
                    >
                        {commonStrings.save}
                    </Button>
                </div>

            </div>
        )
    }

    saveLocale(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault()
        }

        const params = this.state.editLocale;
        this.toggleLocaleEditor()

        this.setState({
            isLoading: true,
            editLocaleChanged: false, editLocale: resourceHelper.emptyLocale()
        })

        if (params.id) {
            ResourceApiService.updateLocale(params)
                .then(res => {
                    this.getUser()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                })
                .finally(() => this.setState({isLoading: false}));
        } else {
            ResourceApiService.createLocale(params)
                .then(res => {
                    this.getUser()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                })
                .finally(() => this.setState({isLoading: false}));
        }
    }

    deleteLocale(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault()
        }
        const params = this.state.editLocale
        this.toggleLocaleEditor()

        this.setState({
            isLoading: true,
            editLocaleChanged: false, editLocale: resourceHelper.emptyLocale()
        })

        if (params.id) {
            ResourceApiService.deleteLocale(params)
                .then(res => {
                    if (res.error) {
                        this.handleNetworkError(res.error)
                    }
                    this.getUser()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                })
                .finally(() => this.setState({isLoading: false}));
        }
    }

    showLocale(e, locale) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        let newLocale = {
            id: locale.id,
            title: locale.title,
            description: locale.description,
            street: locale.address ? locale.address.street : "",
            city: locale.address ? locale.address.city : "",
            country: locale.address ? locale.address.country : "",
            zipcode: locale.address ? locale.address.zipcode : "",
        }

        this.setState({
            showLocaleEditor: true,
            editLocale: newLocale
        })
    }

    resolveShowPp() {
        if (this.props.location.search.indexOf("show") > 0) {
            this.getPP(true)
        }
    }

    checkQuery() {
        const query = new URLSearchParams(this.props.location.search);
        const showTeachers = query.get('sts');
        const showClassTypes = query.get('cts');

        if (showTeachers) this.showTeacherTable()
        if (showClassTypes) this.showClassTypeTable()
    }
}

export default Profile;
